module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Tutorial")]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('timer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.withTImer),
      expression: "withTImer"
    }],
    ref: "timer",
    attrs: {
      "limit": "10"
    },
    on: {
      "timeout": _vm.timeout
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "playing"
    }
  }, [_c('h1', {
    style: ({
      fontFamily: _vm.font
    }),
    attrs: {
      "id": "question"
    }
  }, [_vm._v(_vm._s(_vm.topic.question))]), _vm._v(" "), _vm._l((_vm.topic.choices), function(choice) {
    return _c('div', {
      staticClass: "choice",
      style: ({
        fontFamily: _vm.font
      }),
      on: {
        "click": function($event) {
          _vm.checkAnswer(choice)
        }
      }
    }, [_c('div', {
      staticClass: "a"
    }, [_vm._v("\n        " + _vm._s(choice) + "\n        ")])])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d667685"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tutorial.vue
// module id = 35
// module chunks = 0